require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/es7.symbol.async-iterator.js
// module id = 112
// module chunks = 0 2 3 4 5 6 7 8 11 12 13 14 15 16 17 18 20